export enum ExportCollectionName {
  divisions = 'divisions',
  communities = 'communities',
  communityContacts = 'communityContacts',
  contacts = 'contacts',
  contactTypes = 'contactTypes',
  documents = 'documents',
  homes = 'homes',
  homeContacts = 'homeContacts',
  updates = 'updates',
  buyers = 'buyers',
  defaultPhases = 'default-phases',
  phases = 'phases',
  elevations = 'elevations',
  plans = 'plans',
  schedule = 'schedule',
  phaseTips = 'phaseTips',
  defaultPhaseTips = 'defaultPhaseTips',
  homeSchedule = 'home-schedule',
  homeScheduleItem = 'home-schedule-item',
  users = 'users',
  reports = 'reports',
  homeDocuments = 'home-documents',
  vendors = 'vendors',
  conversations = 'conversations'
}

export interface ExportConfigs {
  collectionName: string;
  extraVariables?: {
    [key: string]: string | number;
  };
  getExportData?: () => object;
}
